module.exports = __webpack_public_path__ + "static/media/payment-notdone.0f356f0c.gif";